import { cva } from 'class-variance-authority';
import { cn } from '../../lib/utils';

export const textVariants = cva('', {
  variants: {
    size: {
      small: cn('eye:body-m eye:pr-2xs'),
      default: cn('eye:headline-m eye:absolute'),
      big: cn('eye:numbers-l eye:absolute'),
    },
  },
  defaultVariants: {
    size: 'default',
  },
});
